import { computed } from 'vue'
import { useUserStore } from '@/stores/user/userStore' // přizpůsob podle tvé cesty

const BRAND = import.meta.env.VITE_BRAND || 'hockeybook';

export function usePermissions() {
  const userStore = useUserStore()

  const canCreateContent = computed(() => {
    const roles = userStore.user?.userRoles || []
    if (roles.includes('administrator')) return true
    if (BRAND === 'hockeybook') return true
    return false
  })


  return { canCreateContent }
}